module.exports = __webpack_public_path__ + "media/bootstrap-icons/nut-b9114d42.svg";